// extracted by mini-css-extract-plugin
module.exports = {"label":"FormLabel-label-2d1Wp","hasError":"FormLabel-hasError-2pGUM","isAdvanced":"FormLabel-isAdvanced-1glHh","small":"FormLabel-small-3U2IE","large":"FormLabel-large-3Sn9u"};